import React from "react";

export const CategoryList = (props) => {
  const { data, handleEdit, handleDelete } = props;

  return (
    <div className="overflow-x-auto flex flex-col">
      <table className="w-4xl table-auto border rounded-xl bg-white shadow-sm">
        <thead>
          <tr className="bg-gray-100 text-gray-600 text-left text-sm">
            <th className="px-4 py-3 w-[300px]">Fields</th>
            <th className="px-4 py-3 w-[200px] text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((cat, index) => {
            const isOther = cat.tittle?.trim().toLowerCase() === "other";

            return (
              <tr key={cat._id} className="border-t hover:bg-gray-50">
                <td className="px-4 py-3 flex gap-2">
                  <div className="flex items-center">{index + 1}.</div>
                  <div className="px-4 py-3 font-medium capitalize">{cat.tittle}</div>
                </td>
                <td className="px-3 py-4 text-sm text-grey">
                  <div className="flex justify-end gap-3">
                    {!isOther && (
                      <>
                        <button
                          onClick={() => handleEdit(cat)}
                          className="text-primary text-sm sm:text-base font-semibold"
                        >
                          Edit
                        </button>
                        |
                        <button
                          onClick={() => handleDelete(cat)}
                          className="text-red-700 text-sm sm:text-base font-semibold"
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}

          {data?.length === 0 && (
            <tr>
              <td colSpan="4" className="text-center text-grey py-10">
                No categories found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
